'use strict';

var _regeneratorRuntime = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/mnt/c/Users/lfege/Code/ipfs-nft-sandbox/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var CID = require('cids');

var multicodec = require('multicodec');

var multihashing = require('multihashing-async');

exports = module.exports;
exports.codec = multicodec.DAG_PB;
exports.defaultHashAlg = multicodec.SHA2_256;
/**
 * Calculate the CID of the binary blob.
 *
 * @param {Object} binaryBlob - Encoded IPLD Node
 * @param {Object} [userOptions] - Options to create the CID
 * @param {number} [userOptions.cidVersion=1] - CID version number
 * @param {string} [UserOptions.hashAlg] - Defaults to the defaultHashAlg of the format
 * @returns {Promise.<CID>}
 */

var cid =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(binaryBlob, userOptions) {
    var defaultOptions, options, multihash, codecName, cid;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            defaultOptions = {
              cidVersion: 1,
              hashAlg: exports.defaultHashAlg
            };
            options = Object.assign(defaultOptions, userOptions);
            _context.next = 4;
            return multihashing(binaryBlob, options.hashAlg);

          case 4:
            multihash = _context.sent;
            codecName = multicodec.print[exports.codec];
            cid = new CID(options.cidVersion, codecName, multihash);
            return _context.abrupt("return", cid);

          case 8:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function cid(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.cid = cid;